import Api from "~/core/helper/apiHelper";

export function addVisit(data) {
  Api.post(`stat/visit`, data);
}
